<template>
  <div class="data-grid-input-range">
    <el-popover width="150px"
                trigger="click"
                popper-class="data-grid-input-range-popper"
                placement="bottom-start">
      <template slot="reference">
        <div class="handler">
          <el-input :value="inputVal"
                    type="text"
                    readonly
                    v-bind="$attrs"></el-input>
        </div>
      </template>
      <el-tooltip :value="hasError"
                  :content="`起始值不能${inputClosure ? '大于' : '大于等于'}结束值`"
                  effect="light"
                  manual
                  placement="right">
        <div class="input-range">
          <div class="range-item">
            <div class="label">起始值：</div>
            <el-input v-model.number="range.startVal"
                      type="number"
                      placeholder="起始值"></el-input>
            <el-checkbox v-model="range.startClosure">包含</el-checkbox>
          </div>
          <div class="range-item">
            <div class="label">结束值：</div>
            <el-input v-model.number="range.endVal"
                      type="number"
                      placeholder="结束值"></el-input>
            <el-checkbox v-model="range.endClosure">包含</el-checkbox>
          </div>
        </div>
      </el-tooltip>
    </el-popover>
    <div v-if="hasInputVal"
         class="close"
         @click.stop="cleanInputVal">
      <i class="el-icon-circle-close"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataGridInputRange',
  props: {
    value: String
  },
  data () {
    return {
      show: true,
      range: {
        startVal: undefined,
        startClosure: true,
        endVal: undefined,
        endClosure: true
      }
    }
  },
  computed: {
    hasInputVal () {
      return typeof this.range.startVal === 'number' || typeof this.range.endVal === 'number'
    },
    hasError () {
      if (typeof this.range.startVal === 'number' && typeof this.range.endVal === 'number') {
        return this.inputClosure ? this.range.endVal < this.range.startVal : this.range.endVal <= this.range.startVal
      }
    },
    inputClosure () {
      return this.range.startClosure && this.range.endClosure
    },
    inputVal () {
      if (this.hasInputVal && !this.hasError) {
        let startVal = typeof this.range.startVal === 'number' ? this.range.startVal : ''
        let endVal = typeof this.range.endVal === 'number' ? this.range.endVal : ''
        return `${this.range.startClosure ? '[' : '('}${startVal},${endVal}${this.range.endClosure ? ']' : ')'}`
      } else {
        return ''
      }
    }
  },
  methods: {
    parseInputVal (val) {
      if (val) {
        this.range.startClosure = val.startsWith('[')
        this.range.endClosure = val.endsWith(']')
        let rangeVal = val.substring(1, val.length - 1)
        if (rangeVal) {
          let values = rangeVal.split(',', 2)
          let startValue = values[0]
          let endValue = values[1]
          if (startValue && !isNaN(startValue)) {
            this.range.startVal = Number(startValue)
          } else {
            this.range.startVal = undefined
          }
          if (endValue && !isNaN(endValue)) {
            this.range.endVal = Number(endValue)
          } else {
            this.range.endVal = undefined
          }
        } else {
          this.range.startVal = undefined
          this.range.endVal = undefined
        }
      } else {
        this.range.startVal = undefined
        this.range.endVal = undefined
      }
    },
    cleanInputVal () {
      this.range.startVal = undefined
      this.range.endVal = undefined
    }
  },
  created () {
    this.parseInputVal(this.value)
  },
  watch: {
    inputVal: {
      handler: function (val) {
        this.$emit('input', val)
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">
  .data-grid-input-range {
    &:hover {
      & > .close {
        display: block;
      }
    }
    .handler {
      .el-input {
        .el-input__inner {
          padding-left: 30px;
        }
      }
    }
    & > .close {
      display: none;
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      color: #C0C4CC;
      cursor: pointer;
      &:hover {
        color: #909399;
      }
    }
  }
  .data-grid-input-range-popper {
    padding: 15px!important;
    .input-range {
      & > .range-item {
        display: flex;
        align-items: center;
        & > .label {
          margin-right: 8px;
          color: #606266;
          font-size: 12px;
        }
        .el-input {
          width: 100px;
        }
        .el-checkbox {
          margin-left: 12px;
          .el-checkbox__label {
            font-size: 12px;
          }
        }
        & + .range-item {
          margin-top: 10px;
        }
      }
    }
  }
</style>
